import KpiSettingsPage from "./KpiSettingsPage";

export default KpiSettingsPage